const publicRoutes = ['login', 'create-account'];
export default publicRoutes;
